<template>
  <pt-video-detail class="pt-video-detail__page"></pt-video-detail>
</template>

<script>
import PtVideoDetail from 'cps/tool-operation/pt-video-manage/pt-video-detail/withData'
export default {
  name: 'pt-video-detail__view',
  components: {
    'pt-video-detail': PtVideoDetail
  }
}
</script>
